import ChildrenManager from "@/components/parent/ChildrenManager";
import { useParentData } from "@/hooks/useParentData";

export default function ParentChildren() {
  const { children, loading, reload } = useParentData();
  return (
    <div className="container mx-auto px-4 py-8">
      <header className="mb-6">
        <h1 className="text-3xl font-bold">Children</h1>
        <p className="text-muted-foreground">Add and manage the children linked to your account.</p>
      </header>
      {loading ? <p className="text-muted-foreground">Loading…</p> : <ChildrenManager children={children} onChange={reload} />}
    </div>
  );
}
